import React, { Component } from 'react'
import { Cta, Background, ContentContainer, Title, Subtitle, Button } from './styles'

class SimpleCTA extends Component {
  render() {
    const { content, mt, size } = this.props
    return (
      <Cta size={size} mt={mt}>
        <Background style={{ backgroundImage: `url(${content.image})` }} />
        <ContentContainer>
          <Title>{content.title}</Title>
          {content.subtitle ? <Subtitle>{content.subtitle}</Subtitle> : null}
          <Button href={content.link.url} target={content.link.target}>
            {content.link.content}
          </Button>
        </ContentContainer>
      </Cta>
    )
  }
}

export default SimpleCTA



// WEBPACK FOOTER //
// ./src/components/SimpleCTA/index.js